import { connect } from 'react-redux'
import StatusPulling from './status-pulling'
import { getSchoolData } from '../../../../../../../stores/school-data/school-data.selectors'

const mapStateToProps = state => {
  const school = getSchoolData(state)
  return {
    id: school.id,
    statusColor: school.wonde.color
  }
}

export default connect(
  mapStateToProps,
  null
)(StatusPulling)
